/* eslint-disable max-len */
import { UtilityFunctionsService } from 'src/app/shared/providers/utility-functions.service';
import { UploadFileService } from 'src/app/shared/providers/upload-file.service';
import { UserDataService } from 'src/app/shared/providers/user-data.service';
import { MatSnackBar, MatSnackBarContainer } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { CardsService } from 'src/app/shared/providers/cards.service';
import { ModelCardService } from './../../models/card';
import { CARD_TYPE, CARD_PURCHASE_STATUS } from 'src/app/models/card';
import { MockDataService } from 'src/app/shared/providers/mock-data.service';
import { SettingsService } from './../../shared/providers/settings.service';
import { Component, Inject, OnInit, ViewEncapsulation, ViewChild, TemplateRef, ChangeDetectorRef, ElementRef } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { FirebaseAuthService } from 'src/app/shared/providers/firebase-auth.service';
import { HttpClient } from '@angular/common/http';
import { LOG_LEVEL_OPTION } from 'src/app/models/common';
import { IappurchaseService } from 'src/app/shared/providers/iappurchase.service';
import 'cordova-plugin-purchase/www/store.d';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { RatingService } from '../../shared/providers/rating.service';
import { DialogData, ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { POPUP_TEXT } from 'src/app/shared/text/popup-texts';
import { DOCUMENT } from '@angular/common';
import { FOOTER_MODE } from 'src/app/models/menu';

@Component({
  selector: 'app-service-settings',
  templateUrl: './service-settings.component.html',
  styleUrls: ['./service-settings.component.scss', './model-comments.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ServiceSettingsComponent implements OnInit {  /**
eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee * Get boundary reasoning for a given image index (for boundary cell UI)
eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee * Tries to extract .reasoning from boundaryResults, or returns empty string
eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee */
  getBoundaryReasoning(imageIndex: number): string {
    const boundary = this.boundaryResults[imageIndex];
    if (!boundary) {
      // console.log(`getBoundaryReasoning: No boundary data for index ${imageIndex}`);
      return '';
    }

    // console.log(`getBoundaryReasoning: Found boundary data for index ${imageIndex}:`, boundary);

    // If boundary.reasoning exists, return it
    if (boundary.reasoning) {
      // console.log(`getBoundaryReasoning: Returning reasoning: "${boundary.reasoning}"`);
      return boundary.reasoning;
    }

    // console.log(`getBoundaryReasoning: No reasoning found for index ${imageIndex}`);
    return '';
  }



  LOG_LEVEL_OPTION = LOG_LEVEL_OPTION;
  public currentFooterMode: FOOTER_MODE = FOOTER_MODE.SERVICE

  public originalUid: string;
  public customUid: string;
  public newCustomUid: string;

  public mockCardsForm: ModelCardService[];

    public error: string;
  public approvedProdcuts: any[] = [];

  public modelIdForTextures: string;
  public texturesRootPath: string;

  public aiFramesCount: number;
  public aiTemperature: number = 0.4; // Default temperature
  public aiThinkingBudget: number = 4000; // Default thinking budget for OpenAI
  public selectedTabIndex: number = 0;
  private isInitialized: boolean = false;
  public selectedProvider: 'gemini' | 'openai';
  public selectedOpenAIModel: string;
  public openAIModels: Array<{ value: string; label: string }> = [
    { value: 'gpt-5', label: 'GPT-5 · Vision & Reasoning' },
    { value: 'gpt-5.1', label: 'GPT-5.1 · Reasoning' },
    { value: 'gpt-5-chat-latest', label: 'GPT-5 Chat Latest' },
    { value: 'gpt-5-mini', label: 'GPT-5 mini' },     // быстрее/дешевле
    { value: 'gpt-5-nano', label: 'GPT-5 nano' },     // самый лёгкий
  ];
  public selectedGeminiModel: string;
  public geminiModels: Array<{ value: string; label: string }> = [
    { value: 'googleai/gemini-2.5-pro', label: 'Gemini 2.5 Pro' },
    { value: 'googleai/gemini-3-pro-preview', label: 'Gemini 3.0 Pro' }
  ];
  public providerDisplayName: string;

  // AI Analysis Table properties
  public testImages: Array<{name: string; posterUrl: string; videoUrl: string; preview_link_web?: string}> = [];

  public promptTypes: Array<{
    key: string;
    id: string;
    name: string;
    prompt: string;
    systemPrompt: string;
    jsonPrompt?: string;
    jsonPromptAvailable: boolean;
  }> = [
    { key: 'gemini', id: 'gemini-curator', name: 'Gemini Analysis', prompt: '', systemPrompt: '', jsonPrompt: undefined, jsonPromptAvailable: false },
    { key: 'gemini-wiki', id: 'gemini-wikipedia', name: 'Gemini Analysis WIKI', prompt: '', systemPrompt: '', jsonPrompt: undefined, jsonPromptAvailable: false },
    { key: 'boundary', id: 'boundary-rater', name: 'Boundary Analysis Prompt', prompt: '', systemPrompt: '', jsonPrompt: undefined, jsonPromptAvailable: false }
  ];
  public tablePromptTypes: any[];
  private jsonPrompts: { [key: string]: string } = {};

  // Rating system data - now keyed by imageIndex and promptId
  public userRatings: { [imageIndex: number]: { [promptId: string]: number | null } } = {};
  public averageRatings: { [imageIndex: number]: { [promptId: string]: number | null } } = {};
  public ratingCounts: { [imageIndex: number]: { [promptId: string]: number } } = {};
  public isSavingRating: { [imageIndex: number]: { [promptId: string]: boolean } } = {};
  public isDeletingRatings = false;

  // Model comments data
  public modelComments: { [imageIndex: number]: string } = {};
  public modelCommentsLastUpdatedBy: { [imageIndex: number]: string } = {};
  public modelCommentsLastUpdated: { [imageIndex: number]: any } = {}; // Firestore timestamp
  public isSavingComment: { [imageIndex: number]: boolean } = {};
  public showCommentForm: { [imageIndex: number]: boolean } = {};

  // Boundary conditions data
  public boundaryResults: { [imageIndex: number]: { loading: boolean; score: number; ambiguity: string; reasoning?: string } } = {};

  public analysisResults: { [imageIndex: number]: { [promptType: string]: { loading: boolean; result: string } } } = {};
  public isAnalyzing: boolean = false;
  public isCancelled: boolean = false;
  public isAnalyzingClarity: boolean = false;
  public isClarityAnalysisCancelled: boolean = false;
  public isAnalyzingWiki: boolean = false;
  public isWikiAnalysisCancelled: boolean = false;
  public isStartingOnboarding: boolean = false;

  // Prompt editing properties
  public editingPrompt: { [promptKey: string]: boolean } = {};
  public editedPromptText: { [promptKey: string]: string } = {};
  public showFullAnalysis: { [imageIndex: number]: { [promptType: string]: boolean } } = {};

  // Demo data loading
  public demoDataLoaded: boolean = false;
  // Remove demoDataMode property - not needed anymore

  // Image dialog properties
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('imageDialogTemplate') imageDialogTemplate!: TemplateRef<any>;
  public selectedImage: {name: string; posterUrl: string; videoUrl: string; preview_link_web?: string} | null = null;

  // eslint-disable-next-line max-len
  constructor(private formBuilder: UntypedFormBuilder, private http: HttpClient, public firebaseAuth: FirebaseAuthService,
    public settingsService: SettingsService, public cardService: CardsService,  private mockService: MockDataService,
    public utilityService: UtilityFunctionsService,
    public iapPurchaseService: IappurchaseService,
    public userDataService: UserDataService, public router: Router, public uploadFileService: UploadFileService,
    @Inject(DOCUMENT) private document: any, public dialog: MatDialog, private route: ActivatedRoute,
    private ratingService: RatingService, private cdr: ChangeDetectorRef
    ) { }

  ngOnInit() {

    // this.firebaseAuth.clearLocalStorageData();

    this.firebaseAuth.getUserUid().then(data => {
      this.originalUid = this.firebaseAuth.currentUser.uid;
    });
    this.firebaseAuth.getUserUid().then(uid => {
      this.customUid = uid;
    });

    this.mockCardsForm = this.mockService.mockCardsDiscovery;
    console.log(this.mockService.mockCardsDiscovery);

    // Initialize AI frames count from settings - default to 4 (video mode)
    this.aiFramesCount = 4;
    this.settingsService.aiFramesCount = 4;

    // Initialize AI temperature from settings
    this.aiTemperature = this.settingsService.aiTemperature;

    // Initialize AI thinking budget from settings
    this.aiThinkingBudget = this.settingsService.aiThinkingBudget || 4000;

    // Initialize AI provider and model
    this.selectedProvider = this.settingsService.aiProvider;
    this.selectedOpenAIModel = this.settingsService.aiOpenAIModel;
    this.selectedGeminiModel = this.settingsService.aiGeminiModel;
    this.ensureSelectedOpenAIModelOption();
    this.updateProviderDisplayName();

    // Check for URL parameters to auto-select tab
    this.route.queryParams.subscribe(params => {
      if (params['ai'] !== undefined) {
        this.selectedTabIndex = 2; // AI Settings tab
      } else if (params['visuals'] !== undefined) {
        this.selectedTabIndex = 1; // Visuals tab
      } else if (params['advanced'] !== undefined) {
        this.selectedTabIndex = 0; // Advanced tab
      }
    });

  // Load AI base data from ai-base.json first, then initialize table
    this.loadAiBaseData().then(() => {
      // Initialize AI analysis table after data is loaded
      this.initializeAnalysisTable();
      this.loadAndSetPrompts();

      // Try to load demo data
      this.loadDemoData();
    });

    // Mark as initialized after all setup is complete
    this.isInitialized = true;
    this.tablePromptTypes = this.promptTypes.filter(p => p.key !== 'boundary');

    // Initialize Gemini model default
    this.selectedGeminiModel = 'googleai/gemini-2.5-pro';
    if (this.selectedProvider === 'gemini') {
      this.updateProviderDisplayName();
    }
  }

  public async startSellerOnboarding(): Promise<void> {
    if (!this.firebaseAuth.currentUser) {
      this.utilityService.showImportantSnackBar('Please sign in first', 2000);
      return;
    }
    this.isStartingOnboarding = true;
    try {
      const response = await this.cardService.startStripeOnboarding(this.firebaseAuth.currentUser.uid);
      if (response?.onboardingUrl) {
        window.location.href = response.onboardingUrl;
        return;
      }
      this.utilityService.showImportantSnackBar('Onboarding URL is missing', 2000);
    } catch (error) {
      this.utilityService.showImportantErrorSnackBar(`Onboarding error: ${error}`, 3000);
    } finally {
      this.isStartingOnboarding = false;
    }
  }

  onProviderChange(): void {
    this.settingsService.aiProvider = this.selectedProvider;
    if (this.selectedProvider === 'openai') {
      this.selectedOpenAIModel = this.settingsService.aiOpenAIModel || this.selectedOpenAIModel || 'gpt-4o';
      this.ensureSelectedOpenAIModelOption();
    } else if (this.selectedProvider === 'gemini') {
      this.selectedGeminiModel = this.selectedGeminiModel || 'googleai/gemini-2.5-pro';
    }
    this.updateProviderDisplayName();
    this.utilityService.showSnackBar(`AI Provider set to ${this.providerDisplayName}`, 2000);
  }

  onOpenAIModelChange(): void {
    this.ensureSelectedOpenAIModelOption();
    this.settingsService.aiOpenAIModel = this.selectedOpenAIModel;
    this.updateProviderDisplayName();
    this.utilityService.showSnackBar(`OpenAI model set to ${this.getOpenAIModelLabel(this.selectedOpenAIModel)}`, 2000);
  }

  onGeminiModelChange(): void {
    this.settingsService.aiGeminiModel = this.selectedGeminiModel;
    this.updateProviderDisplayName();
    this.utilityService.showSnackBar(`Gemini model set to ${this.getGeminiModelLabel(this.selectedGeminiModel)}`, 2000);
  }

  updateProviderDisplayName(): void {
    if (this.selectedProvider === 'openai') {
      this.providerDisplayName = `🤖 OpenAI (${this.getOpenAIModelLabel(this.selectedOpenAIModel)})`;
    } else {
      this.providerDisplayName = `🔮 Google Gemini (${this.getGeminiModelLabel(this.selectedGeminiModel)})`;
    }
  }

  private ensureSelectedOpenAIModelOption(): void {
    if (!this.selectedOpenAIModel || this.selectedOpenAIModel.trim().length === 0) {
      this.selectedOpenAIModel = this.openAIModels[0]?.value || 'gpt-4o';
    }

    const exists = this.openAIModels.some(model => model.value === this.selectedOpenAIModel);
    if (!exists) {
      this.openAIModels = [
        ...this.openAIModels,
        { value: this.selectedOpenAIModel, label: this.selectedOpenAIModel }
      ];
    }
  }

  private getOpenAIModelLabel(model: string): string {
    const found = this.openAIModels.find(m => m.value === model);
    if (found) {
      return found.label;
    }
    return model || this.openAIModels[0]?.label || 'Unknown Model';
  }

  private getGeminiModelLabel(model: string): string {
    const found = this.geminiModels.find(m => m.value === model);
    if (found) {
      return found.label;
    }
    return model || this.geminiModels[0]?.label || 'Unknown Model';
  }

  public getProviderFriendlyName(): string {
    if (this.selectedProvider === 'openai') {
      if (this.selectedOpenAIModel && (this.selectedOpenAIModel.includes('gpt-5') || this.selectedOpenAIModel.includes('o1') || this.selectedOpenAIModel.includes('o3'))) {
        return 'OpenAI Thinking';
      }
      return 'OpenAI';
    }
    return 'Gemini';
  }

  async getToken() {
    console.log(await this.firebaseAuth.currentUser.getIdToken())
  }

  applyUid() {
    this.customUid = this.newCustomUid;
    this.settingsService.setCustomUidInLocalstorage(this.newCustomUid);
    this.utilityService.showSnackBar('UID changed to: ' + this.newCustomUid + ' Dont forget to relaunch app!', 500);
  }


  public navigateToFeed(): void {
    this.router.navigateByUrl('/home');
  }


  public patchSnackBarAnimation(): void {
        // DIRTY-WORKAROUND TO PATCH ANGULAR ANIMATION;
        const c: any = MatSnackBarContainer.ɵcmp as any;
        const d = c.data.animation[0];
        const e = c.data.animation[0].definitions[0].styles.styles.transform = `scale(${this.settingsService.snackBarAppearScale})`;
        c.data.animation[0].definitions[3].animation.timings = `${this.settingsService.snackBarHideTiming}ms cubic-bezier(0.4, 0.0, 1, 1)`;
        c.data.animation[0].definitions[2].animation.timings = `${this.settingsService.snackBarAppearTiming}ms cubic-bezier(0, 0, 0.2, 1)`;

  }

  clearUploads(): void {
    this.firebaseAuth.deleteDocumentsWithLoadStatusNotFinished().then(()=> {
      this.uploadFileService.uploadModels = [];
    });
  }

  restorePurchases(): void {
    this.iapPurchaseService.restorePurchases();
  }

  manageBilling(): void {
    this.iapPurchaseService.manageBilling();
  }

  manageSubscriptions(): void {
    this.iapPurchaseService.manageSubscriptions();
  }

  private deleteAllModels(): void {
    this.userDataService.uploadedCards.forEach((el) => {
      this.cardService.deleteModelPostRequest(el);
    });
  }

  public openDeleteCardConfirmationDialog() {
    const dialogConfig: MatDialogConfig<DialogData> = {
      data: this.utilityService.applyPopupText(POPUP_TEXT.DELETE_ALL_MODELS)
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
          this.deleteAllModels();
      }
    });
  }

  clearPurchaseQueue(): void {
    // this.store.autoFinishTransactions = true;
    // this.store.refresh();
  }

  getAllProducts(): void {
    // this.store.refresh();
    // const ev = this.store.when('product').updated((p: IAPProduct) => {
    //   console.log(p.id + ' ' + p.title + ' ' + p.state);
    //   console.log(p);
    //   if(p.state === 'approved') {
    //     p.finish();
    //     this.approvedProdcuts.push(JSON.stringify(p));
    //   }
    // });
  }

  addTexturesToModel(): void {
    if (!this.modelIdForTextures || this.modelIdForTextures.trim() === '') {
      this.utilityService.showSnackBar('Please enter a valid Model ID', 3000);
      return;
    }

    if (!this.texturesRootPath || this.texturesRootPath.trim() === '') {
      this.utilityService.showSnackBar('Please enter a valid Textures Root Path', 3000);
      return;
    }

    this.firebaseAuth.addTexturesToModel(this.modelIdForTextures.trim(), this.texturesRootPath.trim()).then(() => {
      this.utilityService.showSnackBar(`Textures and root path added to model: ${this.modelIdForTextures}`, 3000);
      this.modelIdForTextures = '';
      this.texturesRootPath = '';
    }).catch((error) => {
      this.utilityService.showSnackBar(`Error adding textures: ${error.message}`, 5000);
      console.error('Error adding textures:', error);
    });
  }



  onFramesCountChange(newValue: number): void {
    if (newValue < 1 || newValue > 4) {
      this.utilityService.showSnackBar('AI frames count must be between 1 and 4', 3000);
      return;
    }

    this.settingsService.aiFramesCount = newValue;
    this.aiFramesCount = newValue; // Update local property
    this.utilityService.showSnackBar(`AI frames count automatically saved: ${newValue} (${newValue === 1 ? 'Image mode' : 'Video mode'})`, 2000);
  }

  saveAiFramesCount(): void {
    if (this.aiFramesCount < 1 || this.aiFramesCount > 4) {
      this.utilityService.showSnackBar('AI frames count must be between 1 and 4', 3000);
      return;
    }

    this.settingsService.aiFramesCount = this.aiFramesCount;
    const mode = this.aiFramesCount === 1 ? 'Image mode' : 'Video mode';
    this.utilityService.showImportantSnackBar(`AI frames count saved successfully: ${this.aiFramesCount} (${mode})`, 0, 3000);
  }

  resetAiFramesCountToDefault(): void {
    this.aiFramesCount = 4; // Default to 4 frames (video mode)
    this.settingsService.aiFramesCount = 4;
    this.utilityService.showSnackBar('AI frames count reset to default (4 frames - video mode)', 3000);
  }


  onTabChange(index: number): void {
    this.selectedTabIndex = index;

    // Only update URL if component is fully initialized
    if (!this.isInitialized) {
      return;
    }

    // Update URL with corresponding query parameter for each tab
    let queryParams = {};

    switch (index) {
      case 0:
        queryParams = { advanced: '' };
        break;
      case 1:
        queryParams = { visuals: '' };
        break;
      case 2:
        queryParams = { ai: '' };
        break;
      default:
        queryParams = {};
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      replaceUrl: true
    });
  }

  // AI Analysis Table Methods
  initializeAnalysisTable(): void {
    // Initialize editing states and results structures
    this.promptTypes.forEach(p => {
        this.editingPrompt[p.key] = false;
    });

    this.testImages.forEach((_, imageIndex) => {
        this.initializeImageStructures(imageIndex);
    });
  }

  private initializeImageStructures(imageIndex: number): void {
      if (!this.analysisResults[imageIndex]) this.analysisResults[imageIndex] = {};
      if (!this.showFullAnalysis[imageIndex]) this.showFullAnalysis[imageIndex] = {};
      if (!this.userRatings[imageIndex]) this.userRatings[imageIndex] = {};
      if (!this.averageRatings[imageIndex]) this.averageRatings[imageIndex] = {};
      if (!this.ratingCounts[imageIndex]) this.ratingCounts[imageIndex] = {};
      if (!this.isSavingRating[imageIndex]) this.isSavingRating[imageIndex] = {};

      this.promptTypes.forEach(promptType => {
          this.analysisResults[imageIndex][promptType.key] = { loading: false, result: '' };
          this.showFullAnalysis[imageIndex][promptType.key] = false;
          this.userRatings[imageIndex][promptType.id] = null;
          this.averageRatings[imageIndex][promptType.id] = null;
          this.ratingCounts[imageIndex][promptType.id] = 0;
          this.isSavingRating[imageIndex][promptType.id] = false;
      });

      this.modelComments[imageIndex] = '';
      this.modelCommentsLastUpdatedBy[imageIndex] = '';
      this.modelCommentsLastUpdated[imageIndex] = null;
      this.isSavingComment[imageIndex] = false;
      this.showCommentForm[imageIndex] = false;

      const imageName = this.testImages[imageIndex]?.name;
      if (imageName) {
          // this.promptTypes.forEach(promptType => {
          //     this.loadRatingForImageAndPrompt(imageIndex, imageName, promptType.id);
          // });
          this.loadCommentForImage(imageIndex, imageName);
      }
  }

  private async loadAndSetPrompts(): Promise<void> {
    // First, set system default prompts
    this.promptTypes.forEach(p => {
        if (p.key === 'gemini') p.systemPrompt = this.getEditorPromptText();
        if (p.key === 'gemini-wiki') p.systemPrompt = this.getWikipediaEditorPromptText();
        if (p.key === 'boundary') p.systemPrompt = this.getBoundaryPromptTemplate();
    });

    // Try to load prompts from JSON
    try {
        const timestamp = new Date().getTime();
        const response = await this.http.get<any>(`assets/ai-inputs.json?t=${timestamp}`).toPromise();
        if (response && response.prompts && Array.isArray(response.prompts)) {
            response.prompts.forEach((p: {key: string; prompt: string}) => {
                const promptType = this.promptTypes.find(pt => pt.key === p.key);
                if (promptType) {
                    promptType.jsonPrompt = p.prompt;
                    promptType.jsonPromptAvailable = true;
                }
            });
            this.utilityService.showSnackBar('Successfully loaded prompts from JSON.', 2000);
        }
    } catch (error) {
        console.warn('Could not load prompts from ai-inputs.json:', error);
        this.utilityService.showSnackBar('Could not load prompts from JSON, using system defaults.', 3000);
    }

    // Set initial prompt values
    this.promptTypes.forEach(p => {
        p.prompt = p.jsonPrompt || p.systemPrompt;
    });
  }

  public resetPromptToDefault(promptKey: string, type: 'system' | 'json'): void {
    const promptType = this.promptTypes.find(p => p.key === promptKey);
    if (!promptType) return;

    if (type === 'system') {
        promptType.prompt = promptType.systemPrompt;
        this.utilityService.showSnackBar(`${promptType.name} reset to SYSTEM default.`, 2000);
    } else if (type === 'json' && promptType.jsonPromptAvailable) {
        promptType.prompt = promptType.jsonPrompt;
        this.utilityService.showSnackBar(`${promptType.name} reset to JSON default.`, 2000);
    }
  }

    getEditorPromptText(): string {
      return `
  You are a Specialist Curator at 3DWay.
  Goal: write a concise gallery label for a GENERAL audience.
  The provided object is titled "\${cardTitle}". Use this as a strong hint for the object's identity, but verify against the visual evidence. Prioritize the title if the image is ambiguous.
  Input: one or more renders of a 3-D asset. An optional title may be provided as a hint.

  Respond **ONLY with valid JSON**, no markdown:

  {
    "model_name": "Canonical short name of the object (≤3 words, no 3D terms)",
    "short_description": "Compose a concise, exhibit-style label (≤150 characters) that spotlights the model's cultural or historical significance and sparks curiosity, describe key model features. Do not repeat model_name in first sentence.",
    "technical_description": "Few keywords about how your sure about your description of the object not more 150 symbols"
  }


  Rules:
  1. Do NOT mention "3D model", "render", polygon count, file format, or background.
  2. Sentence 1 → canonical name (+ up to 2 striking traits).
    • If object_type provided, use that exact phrase.
    • If the object is generic (e.g., apple) *and* no unusual traits are visible, keep to ≤3 words.
  3. Sentence 2 → intriguing fact, use-case, or cultural note suitable for lay readers.
    • Adopt {style_context} voice if supplied (e.g., marine-engineer explaining a steam boiler).
  4. Mention at most one material or era; omit any detail you can't infer with high confidence.
  5. Stay positive and certain; avoid "looks like", "maybe", negatives, or filler words :contentReference[oaicite:3]{index=3}.
  6. Keep within 130-180 characters total.
  7. Forbidden tokens: ["3D model", "low-poly", "download"].

  No markdown, no extra text outside the JSON structure.
  `;
    }

    getWikipediaEditorPromptText(): string {
      return `
  You are a Professional Wikipedia Editor contributing to encyclopedic articles.
  Goal: write a comprehensive, neutral encyclopedia entry for a general reference audience.
  The provided object is titled "\${cardTitle}". Use this as a strong hint for the object's identity, but verify against the visual evidence. Prioritize the title if the image is ambiguous.
  Input: one or more renders of a 3-D asset. An optional title may be provided as a hint.

  Respond **ONLY with valid JSON**, no markdown:

  {
    "model_name": "Canonical encyclopedia title of the object (≤3 words, no 3D terms)",
    "short_description": "Encyclopedic one-sentence definition (≤150 characters) focusing on classification, origin, and primary function or historical significance",
    "technical_description": "Few keywords about how your sure about your description of the object not more 150 symbols"  }

  Rules:
  1. Use neutral, encyclopedic tone suitable for Wikipedia or Britannica.
  2. Do NOT mention "3D model", "render", polygon count, file format, or background.
  3. Focus on factual, verifiable information about the object type.
  4. Include historical context, cultural significance, and technical details.
  5. Use precise terminology and avoid colloquialisms.
  6. Maintain objectivity and avoid subjective descriptions.
  7. Structure information logically from general to specific.
  8. Forbidden tokens: ["3D model", "low-poly", "download", "amazing", "beautiful"].

  No markdown, no extra text outside the JSON structure.
  `;
    }

    getBoundaryPromptTemplate(): string {
      return `
  You are an **AI quality-rater** for 3DWay.
  Goal: judge both (a) linguistic clarity and (b) evidential certainty
  of a short description for a single 3-D asset.

  DEFINITIONS
  • *Clarity*  – how easily an average reader can picture the object.
  • *Ambiguity* – risk that the described identity could be wrong or
    cannot be confirmed from a typical render.

  PENALTY HEURISTICS
  1. The **more specific the claim** (proper noun, make/model, exact era),
    the **more distinctive traits (≥ 2) must be cited**.
    • "Tommy Gun" + "drum magazine, ribbed barrel" → OK
    • "Tommy Gun" без доказательств → High ambiguity
  2. Generic labels that avoid guessing score higher.
  3. Over-confident history claims ("infamous in WWII") without hard
    evidence raise ambiguity.
  4. If the description **admits uncertainty** ("appears to be", "likely")
    *and* stays generic, treat as *Medium* ambiguity, not High.
  5. If the view angle (e.g., thin profile) would hide key details, assume
    higher ambiguity unless text reflects that limitation.

  Return **JSON only**, no markdown, no extra keys:

  {
    "clarity_score": <integer 0-100>,
    "ambiguity_level": "<Very Low | Low | Medium | High | Very High>",
    "reasoning": "<≤150 chars: cite key phrase(s) that drove your score>"
  }

  SCORING GUIDE
  - **90-100**  Very clear; specific claims are fully justified by unique traits.
  - **70-89**   Mostly clear; minor leaps of faith or small missing details.
  - **50-69**   Some clarity, but notable speculation / missing evidence.
  - **30-49**   Vague or over-specific with little support.
  - **0-29**    Extremely ambiguous or self-contradictory.

  SHORT DESCRIPTION (do **not** copy delimiters):
  <<<
  {{originalAnalysis}}
  >>>
  `;
    }




    async analyzeImage(imageIndex: number, promptTypeKey: string, customModel?: string): Promise<void> {
    // Check if image exists
    if (!this.testImages[imageIndex]) {
      this.utilityService.showSnackBar('Image not found', 3000);
      return;
    }

    if (this.analysisResults[imageIndex][promptTypeKey].loading) {
      return;
    }

    this.analysisResults[imageIndex][promptTypeKey].loading = true;
    this.analysisResults[imageIndex][promptTypeKey].result = '';

    try {
      const promptType = this.promptTypes.find(p => p.key === promptTypeKey);
      const image = this.testImages[imageIndex];

      // Use video URL if available, otherwise fallback to poster URL
      const contentUrl = image.videoUrl || image.posterUrl;
      const isVideo = !!image.videoUrl;

      const mockCard = {
        id: `test_${imageIndex}`,
        cardSharingId: `test_sharing_${imageIndex}`,
        cardTitle: image.name,
        cardContentWeb: contentUrl,
        cardContentMobile: contentUrl,
        cardPosterMobile: image.posterUrl,
        cardPosterWeb: image.posterUrl,
        cardDescription: isVideo ? `[VIDEO_MODE] Test analysis with ${this.aiFramesCount} frames` : `[IMAGE_MODE] Test analysis`,
        cardAuthor: 'Test',
        cardCategory: 'Test',
        modifiedDate: new Date().toISOString(),
        cardPrice: 0,
        purchaseStatus: CARD_PURCHASE_STATUS.DEFAULT_3DWAY,
        cardType: CARD_TYPE.MODEL
      };

      const originalPrompt = this.settingsService.aiPrompt;
      const originalFramesCount = this.settingsService.aiFramesCount;
      const originalTemperature = this.settingsService.aiTemperature;
      const originalThinkingBudget = this.settingsService.aiThinkingBudget;

      // Get the prompt from the table (source of truth)
      const promptText = promptType.prompt.replace('${cardTitle}', image.name);

      this.settingsService.aiPrompt = promptText;
      // Let it use the value from settings, don't force to 1
      this.settingsService.aiTemperature = this.aiTemperature; // Use current temperature setting
      this.settingsService.aiThinkingBudget = this.aiThinkingBudget; // Use current thinking budget setting

      try {
        const provider = this.settingsService.aiProvider;
        let providerModel = customModel;
        if (provider === 'openai') {
          providerModel = this.settingsService.aiOpenAIModel;
        } else if (provider === 'gemini') {
          providerModel = this.selectedGeminiModel;
        }
        const aiResponse = await this.cardService.getDataFromAiDescription(mockCard, provider, providerModel, this.aiThinkingBudget);

        this.analysisResults[imageIndex][promptTypeKey].result = JSON.stringify({
          model_name: aiResponse.model_name,
          short_description: aiResponse.short_description,
          technical_description: aiResponse.technical_description
        });

        const providerFriendlyName = this.getProviderFriendlyName();
        const analysisType = promptTypeKey === 'gemini-wiki' ? `${providerFriendlyName} Wiki` : providerFriendlyName;
        const modeMessage = isVideo ? `video mode (${this.settingsService.aiFramesCount} frames)` : 'image mode';
        this.utilityService.showSnackBar(`${analysisType} analysis completed for ${image.name} (${modeMessage})`, 2000);
      } finally {
        this.settingsService.aiPrompt = originalPrompt;
        this.settingsService.aiFramesCount = originalFramesCount;
        this.settingsService.aiTemperature = originalTemperature;
        this.settingsService.aiThinkingBudget = originalThinkingBudget;
      }

    } catch (error) {
      console.error('Error analyzing image:', error);
      const providerFriendlyName = this.getProviderFriendlyName();
      this.analysisResults[imageIndex][promptTypeKey].result = JSON.stringify({
        short_description: `${providerFriendlyName} Error: ${error.message || 'Failed to analyze image'}`,
        technical_description: `${providerFriendlyName} analysis failed for ${this.testImages[imageIndex].name}. Please try again.`
      });
      this.utilityService.showErrorSnackBar(`${providerFriendlyName} analysis failed`, 3000);
    } finally {
      this.analysisResults[imageIndex][promptTypeKey].loading = false;
    }
  }

  async analyzeAllImages(): Promise<void> {
    this.isAnalyzing = true;
    this.isCancelled = false;
    let totalAnalyses = 0;
    let completedAnalyses = 0;
    const providerFriendlyName = this.getProviderFriendlyName();

    // Count total analyses needed for Gemini only
    this.testImages.forEach((_, imageIndex) => {
      if (!this.analysisResults[imageIndex]['gemini'].result) {
        totalAnalyses++;
      }
    });

    if (totalAnalyses === 0) {
      this.isAnalyzing = false;
      this.utilityService.showSnackBar(`All ${providerFriendlyName} analyses already completed!`, 3000);
      return;
    }

    try {
      // Sequential processing - one analysis at a time for Gemini only
      for (const [imageIndex, image] of this.testImages.entries()) {
        // Check if analysis was cancelled
        if (this.isCancelled) {
          this.utilityService.showSnackBar('Analysis cancelled by user', 2000);
          break;
        }

        if (!this.analysisResults[imageIndex]['gemini'].result) {
          const imageName = image.name;

          completedAnalyses++;
          this.utilityService.showSnackBar(
            `[${providerFriendlyName}] Analyzing ${imageName} (${completedAnalyses}/${totalAnalyses})...`,
            2000
          );

          await this.analyzeImage(imageIndex, 'gemini');

          // Check if analysis was cancelled after each image
          if (this.isCancelled) {
            this.utilityService.showSnackBar('Analysis cancelled by user', 2000);
            break;
          }

          await new Promise(resolve => setTimeout(resolve, 500));
        }
      }

      if (!this.isCancelled) {
        this.utilityService.showSnackBar(`All ${providerFriendlyName} analyses completed successfully!`, 3000);
      }
    } catch (error) {
      console.error('Error during Gemini batch analysis:', error);
      this.utilityService.showErrorSnackBar(`Some ${providerFriendlyName} analyses failed. Check console for details.`, 5000);
    } finally {
      this.isAnalyzing = false;
      this.isCancelled = false;
    }
  }

  cancelAnalysis(): void {
    this.isCancelled = true;
    this.isAnalyzing = false;
    this.utilityService.showSnackBar('Analysis cancelled by user', 2000);
  }

  async analyzeAllWiki(): Promise<void> {
    this.isAnalyzingWiki = true;
    this.isWikiAnalysisCancelled = false;
    let totalAnalyses = 0;
    let completedAnalyses = 0;
    const providerFriendlyName = this.getProviderFriendlyName();

    // Count total analyses needed for Wiki only
    this.testImages.forEach((_, imageIndex) => {
      if (!this.analysisResults[imageIndex]['gemini-wiki'].result) {
        totalAnalyses++;
      }
    });

    if (totalAnalyses === 0) {
      this.isAnalyzingWiki = false;
      this.utilityService.showSnackBar(`All ${providerFriendlyName} Wiki analyses already completed!`, 3000);
      return;
    }

    try {
      // Sequential processing - one analysis at a time for Wiki only
      for (const [imageIndex, image] of this.testImages.entries()) {
        // Check if analysis was cancelled
        if (this.isWikiAnalysisCancelled) {
          this.utilityService.showSnackBar('Wiki analysis cancelled by user', 2000);
          break;
        }

        if (!this.analysisResults[imageIndex]['gemini-wiki'].result) {
          const imageName = image.name;

          completedAnalyses++;
          this.utilityService.showSnackBar(
            `[${providerFriendlyName} Wiki] Analyzing ${imageName} (${completedAnalyses}/${totalAnalyses})...`,
            2000
          );

          await this.analyzeImage(imageIndex, 'gemini-wiki');

          // Check if analysis was cancelled after each image
          if (this.isWikiAnalysisCancelled) {
            this.utilityService.showSnackBar('Wiki analysis cancelled by user', 2000);
            break;
          }

          await new Promise(resolve => setTimeout(resolve, 500));
        }
      }

      if (!this.isWikiAnalysisCancelled) {
        this.utilityService.showSnackBar(`All ${providerFriendlyName} Wiki analyses completed successfully!`, 3000);
      }
    } catch (error) {
      console.error('Error during Wiki batch analysis:', error);
      this.utilityService.showErrorSnackBar(`Some ${providerFriendlyName} Wiki analyses failed. Check console for details.`, 5000);
    } finally {
      this.isAnalyzingWiki = false;
      this.isWikiAnalysisCancelled = false;
    }
  }

  cancelWikiAnalysis(): void {
    this.isWikiAnalysisCancelled = true;
    this.isAnalyzingWiki = false;
    this.utilityService.showSnackBar('Wiki analysis cancelled by user', 2000);
  }

  async analyzeAllClarity(): Promise<void> {
    this.isAnalyzingClarity = true;
    this.isClarityAnalysisCancelled = false;
    let totalAnalyses = 0;
    let completedAnalyses = 0;

    // Count total analyses needed for clarity
    this.testImages.forEach((_, imageIndex) => {
      if (!this.hasBoundaryResult(imageIndex)) {
        totalAnalyses++;
      }
    });

    if (totalAnalyses === 0) {
      this.isAnalyzingClarity = false;
      this.utilityService.showSnackBar('All clarity analyses already completed!', 3000);
      return;
    }

    try {
      // Sequential processing - one analysis at a time for clarity
      for (const [imageIndex, image] of this.testImages.entries()) {
        // Check if analysis was cancelled
        if (this.isClarityAnalysisCancelled) {
          this.utilityService.showSnackBar('Clarity analysis cancelled by user', 2000);
          break;
        }

        if (!this.hasBoundaryResult(imageIndex)) {
          const imageName = image.name;

          completedAnalyses++;
          this.utilityService.showSnackBar(
            `[Clarity] Analyzing ${imageName} (${completedAnalyses}/${totalAnalyses})...`,
            2000
          );

          await this.analyzeBoundaryConditions(imageIndex);

          // Check if analysis was cancelled after each image
          if (this.isClarityAnalysisCancelled) {
            this.utilityService.showSnackBar('Clarity analysis cancelled by user', 2000);
            break;
          }

          await new Promise(resolve => setTimeout(resolve, 500));
        }
      }

      if (!this.isClarityAnalysisCancelled) {
        this.utilityService.showSnackBar('All clarity analyses completed successfully!', 3000);
      }
    } catch (error) {
      console.error('Error during clarity batch analysis:', error);
      this.utilityService.showErrorSnackBar('Some clarity analyses failed. Check console for details.', 5000);
    } finally {
      this.isAnalyzingClarity = false;
      this.isClarityAnalysisCancelled = false;
    }
  }

  cancelClarityAnalysis(): void {
    this.isClarityAnalysisCancelled = true;
    this.isAnalyzingClarity = false;
    this.utilityService.showSnackBar('Clarity analysis cancelled by user', 2000);
  }

  clearAllResults(): void {
    this.testImages.forEach((_, imageIndex) => {
      this.promptTypes.forEach(promptType => {
        this.analysisResults[imageIndex][promptType.key] = {
          loading: false,
          result: ''
        };
      });
      // Clear boundary results as well
      this.boundaryResults[imageIndex] = {
        loading: false,
        score: 0,
        ambiguity: '',
        reasoning: ''
      };
    });
    this.utilityService.showSnackBar('All results cleared', 2000);
  }

  clearAllClarityResults(): void {
    this.testImages.forEach((_, imageIndex) => {
      this.boundaryResults[imageIndex] = {
        loading: false,
        score: 0,
        ambiguity: '',
        reasoning: ''
      };
    });
    this.utilityService.showSnackBar('All clarity results cleared', 2000);
  }

    // Prompt editing methods - редактируют промпты таблицы (source of truth)
  startEditingPrompt(promptKey: string): void {
    this.editingPrompt[promptKey] = true;
    const promptType = this.promptTypes.find(p => p.key === promptKey);
    this.editedPromptText[promptKey] = promptType?.prompt || '';
  }

  savePrompt(promptKey: string): void {
    // Сохраняем изменения в промпт таблицы
    const promptType = this.promptTypes.find(p => p.key === promptKey);
    if (promptType) {
      promptType.prompt = this.editedPromptText[promptKey];
      this.utilityService.showSnackBar(`${promptType.name} prompt updated in table`, 2000);
    }
    this.editingPrompt[promptKey] = false;
  }

  cancelEditingPrompt(promptKey: string): void {
    const promptType = this.promptTypes.find(p => p.key === promptKey);
    this.editedPromptText[promptKey] = promptType?.prompt || '';
    this.editingPrompt[promptKey] = false;
  }

  getModelName(imageIndex: number, promptKey: string): string {
    if (!this.analysisResults[imageIndex] || !this.analysisResults[imageIndex][promptKey]) {
      return '';
    }

    const result = this.analysisResults[imageIndex][promptKey].result;
    if (!result) return '';

    try {
      const parsed = JSON.parse(result);
      return parsed.model_name || '';
    } catch (error) {
      console.error('Error parsing analysis result as JSON:', error);
      console.log('Raw result:', result);
      return result;
    }
  }

  // Result display methods
  getShortDescription(imageIndex: number, promptKey: string): string {
    if (!this.analysisResults[imageIndex] || !this.analysisResults[imageIndex][promptKey]) {
      return '';
    }

    const result = this.analysisResults[imageIndex][promptKey].result;
    if (!result) return '';

    try {
      const parsed = JSON.parse(result);
      return parsed.short_description || '';
    } catch (error) {
      console.error('Error parsing analysis result as JSON:', error);
      console.log('Raw result:', result);

      // If not JSON, try to extract content between quotes or return truncated text
      try {
        const match = result.match(/"short_description":\s*"((?:[^"\\]|\\.)*)"/);
        if (match) {
          return match[1].replace(/\\"/g, '"').replace(/\\n/g, '\n');
        }
      } catch (regexError) {
        console.error('Error with regex extraction:', regexError);
      }

      return result.substring(0, 150) + '...';
    }
  }

  getFullDescription(imageIndex: number, promptKey: string): string {
    if (!this.analysisResults[imageIndex] || !this.analysisResults[imageIndex][promptKey]) {
      return '';
    }

    const result = this.analysisResults[imageIndex][promptKey].result;
    if (!result) return '';

    try {
      const parsed = JSON.parse(result);
      return parsed.technical_description || parsed.short_description || '';
    } catch (error) {
      console.error('Error parsing analysis result as JSON:', error);
      console.log('Raw result:', result);

      // If not JSON, try to extract content or return as is
      try {
        const techMatch = result.match(/"technical_description":\s*"((?:[^"\\]|\\.)*)"/);
        if (techMatch) {
          return techMatch[1].replace(/\\"/g, '"').replace(/\\n/g, '\n');
        }
        const shortMatch = result.match(/"short_description":\s*"((?:[^"\\]|\\.)*)"/);
        if (shortMatch) {
          return shortMatch[1].replace(/\\"/g, '"').replace(/\\n/g, '\n');
        }
      } catch (regexError) {
        console.error('Error with regex extraction:', regexError);
      }

      return result;
    }
  }

  toggleFullAnalysis(imageIndex: number, promptKey: string): void {
    if (!this.showFullAnalysis[imageIndex]) {
      this.showFullAnalysis[imageIndex] = {};
    }
    if (this.showFullAnalysis[imageIndex][promptKey] === undefined) {
      this.showFullAnalysis[imageIndex][promptKey] = false;
    }
    this.showFullAnalysis[imageIndex][promptKey] = !this.showFullAnalysis[imageIndex][promptKey];
  }

  hasResult(imageIndex: number, promptKey: string): boolean {
    return !!(this.analysisResults[imageIndex] && this.analysisResults[imageIndex][promptKey] && this.analysisResults[imageIndex][promptKey].result);
  }

  isLoading(imageIndex: number, promptKey: string): boolean {
    return !!(this.analysisResults[imageIndex] && this.analysisResults[imageIndex][promptKey] && this.analysisResults[imageIndex][promptKey].loading);
  }

  // Get character count for short description
  getShortDescriptionCharCount(imageIndex: number, promptKey: string): number {
    const shortDesc = this.getShortDescription(imageIndex, promptKey);
    return shortDesc ? shortDesc.length : 0;
  }

  // Get color class for character count indicator
  getCharCountColorClass(imageIndex: number, promptKey: string): string {
    const charCount = this.getShortDescriptionCharCount(imageIndex, promptKey);
    if (charCount === 0) return 'char-count-none';
    if (charCount < 200) return 'char-count-good';
    if (charCount <= 250) return 'char-count-warning';
    return 'char-count-error';
  }

    // Helper method to determine if URL is a video file (matches backend logic)
  private isVideoUrl(url: string): boolean {
    const videoExtensions = ['.mp4', '.mov', '.avi', '.mkv', '.webm', '.m4v', '.3gp', '.flv', '.wmv', '.ogv'];
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff', '.svg', '.webp'];

    try {
      const urlPath = new URL(url).pathname.toLowerCase();

      // First check if it's definitely an image by extension
      const isDefinitelyImage = imageExtensions.some(ext => urlPath.endsWith(ext));
      if (isDefinitelyImage) {
        return false;
      }

      // Then check for video extensions
      const hasVideoExtension = videoExtensions.some(ext => urlPath.endsWith(ext));

      return hasVideoExtension;
    } catch (error) {
      console.error('Error parsing URL:', error);
      return false;
    }
  }

  // Load AI base data from ai-base.json
  private async loadAiBaseData(): Promise<void> {
    try {
      console.log('Loading AI base data from assets/ai-base.json...');
      const timestamp = new Date().getTime();
      const response = await this.http.get<any[]>(`assets/ai-base.json?t=${timestamp}`).toPromise();

      if (response && Array.isArray(response)) {
        // Map ai-base.json structure to testImages format
        this.testImages = response.map(item => ({
          name: item.title || 'Unknown',
          posterUrl: item.poster_link_web || '',
          videoUrl: item.preview_link_web || '',
          preview_link_web: item.preview_link_web || ''
        }));

        console.log(`Loaded ${this.testImages.length} images from ai-base.json`);
        this.utilityService.showSnackBar(`Loaded ${this.testImages.length} images from AI base data`, 2000);
      } else {
        console.error('Invalid ai-base.json format or empty response');
        this.utilityService.showSnackBar('Failed to load AI base data - invalid format', 3000);
      }
    } catch (error) {
      console.error('Error loading ai-base.json:', error);
      this.utilityService.showSnackBar('Failed to load AI base data', 3000);

      // Fallback to empty array if loading fails
      this.testImages = [];
    }
  }

  // Load demo data from ai-inputs.json if available - match results to ai-base.json models
  public async loadDemoData(): Promise<void> {
    try {
      console.log('Attempting to load demo data from assets/ai-inputs.json...');
      const timestamp = new Date().getTime();
      const response = await this.http.get<any>(`assets/ai-inputs.json?t=${timestamp}`).toPromise();
      this.processAndApplyData(response);
    } catch (error) {
      console.error('Error loading demo data:', error);
      if (error.status === 404) {
        console.log('Demo data file not found at assets/ai-inputs.json');
        this.utilityService.showSnackBar('Demo data file not found', 3000);
      } else {
        console.error('Unexpected error loading demo data:', error);
        this.utilityService.showSnackBar('Error loading demo data', 3000);
      }
    }
  }

  public triggerFileUpload(): void {
    this.fileInput.nativeElement.click();
  }

  public onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const json_data = JSON.parse(reader.result as string);
          this.processAndApplyData(json_data);
          this.utilityService.showSnackBar('Successfully processed data from file', 3000);
          this.cdr.detectChanges(); // Force change detection
        } catch (e) {
          this.utilityService.showSnackBar('Error parsing JSON file', 3000);
          console.error(e);
        }
      };
      reader.readAsText(file);
    }
  }

    private processAndApplyData(response: any): void {
    if (response) {
      console.log('Processing loaded data:', response);

      // Create copies to ensure change detection is triggered
      const newAnalysisResults = JSON.parse(JSON.stringify(this.analysisResults));
      const newShowFullAnalysis = JSON.parse(JSON.stringify(this.showFullAnalysis));
      const newBoundaryResults = JSON.parse(JSON.stringify(this.boundaryResults));

      // Update prompts if they exist in the loaded file
      if (response.prompts && Array.isArray(response.prompts)) {
        let promptsUpdated = 0;
        response.prompts.forEach((p: { key: string; prompt: string }) => {
          const promptType = this.promptTypes.find(pt => pt.key === p.key);
          if (promptType) {
            promptType.prompt = p.prompt;
            promptType.jsonPrompt = p.prompt;
            promptType.jsonPromptAvailable = true;
            promptsUpdated++;
          }
        });
        if (promptsUpdated > 0) {
          console.log(`${promptsUpdated} prompts updated from file.`);
          this.utilityService.showSnackBar(`${promptsUpdated} prompts were updated.`, 2000);
        }
      }

      // Update boundary prompt from file
      if (response.boundaryPrompt && response.boundaryPrompt.prompt) {
        const boundaryPromptType = this.promptTypes.find(pt => pt.key === 'boundary');
        if (boundaryPromptType) {
          boundaryPromptType.prompt = response.boundaryPrompt.prompt;
          boundaryPromptType.jsonPrompt = response.boundaryPrompt.prompt;
          boundaryPromptType.jsonPromptAvailable = true;
          this.utilityService.showSnackBar('Boundary prompt updated from file.', 2000);
        }
      }

      // Update analysis and boundary results
      if (response.images && response.analysisResults) {
        let matchedCount = 0;
        const demoImageNameToIndex = new Map<string, number>();
        response.images.forEach((demoImage: any, demoIndex: number) => {
          demoImageNameToIndex.set(demoImage.name, demoIndex);
        });

        this.testImages.forEach((aiBaseImage, aiBaseIndex) => {
          let demoIndex = demoImageNameToIndex.get(aiBaseImage.name);

          if (demoIndex === undefined) {
            const normalizedAiBaseName = aiBaseImage.name.replace(/[-_]/g, ' ').toLowerCase().trim();
            for (const [demoName, index] of demoImageNameToIndex.entries()) {
              const normalizedDemoName = demoName.replace(/[-_]/g, ' ').toLowerCase().trim();
              if (normalizedAiBaseName === normalizedDemoName) {
                demoIndex = index;
                break;
              }
            }
          }

          if (demoIndex !== undefined && response.analysisResults[demoIndex.toString()]) {
            const demoResults = response.analysisResults[demoIndex.toString()];
            if (!newAnalysisResults[aiBaseIndex]) {
              newAnalysisResults[aiBaseIndex] = {};
              newShowFullAnalysis[aiBaseIndex] = {};
            }
            const resultKeys = Object.keys(demoResults);
            if (demoResults['gemini']?.result) {
              newAnalysisResults[aiBaseIndex]['gemini'] = { loading: false, result: demoResults['gemini'].result };
              newShowFullAnalysis[aiBaseIndex]['gemini'] = false;
            } else if (resultKeys.length > 0 && demoResults[resultKeys[0]]?.result) {
              newAnalysisResults[aiBaseIndex]['gemini'] = { loading: false, result: demoResults[resultKeys[0]].result };
              newShowFullAnalysis[aiBaseIndex]['gemini'] = false;
            }
            if (demoResults['gemini-wiki']?.result) {
              newAnalysisResults[aiBaseIndex]['gemini-wiki'] = { loading: false, result: demoResults['gemini-wiki'].result };
            } else {
              if (!newAnalysisResults[aiBaseIndex]['gemini-wiki']) {
                newAnalysisResults[aiBaseIndex]['gemini-wiki'] = { loading: false, result: '' };
              }
            }
            newShowFullAnalysis[aiBaseIndex]['gemini-wiki'] = false;
            matchedCount++;
          }
        });
        if (matchedCount > 0) {
          this.utilityService.showSnackBar(`Analysis data applied to ${matchedCount} models`, 3000);
        }
      }

      if (response.boundaryResults) {
        let boundaryMatchedCount = 0;
        Object.keys(response.boundaryResults).forEach((key: string) => {
          const demoIndex = parseInt(key, 10);
          let demoImageName = '';
          if (response.images && response.images[demoIndex]) {
            demoImageName = response.images[demoIndex].name;
          } else if (this.testImages[demoIndex]) {
            demoImageName = this.testImages[demoIndex].name;
          }

          if (demoImageName) {
            const aiBaseIndex = this.testImages.findIndex(img => img.name === demoImageName);
            if (aiBaseIndex !== -1) {
              const demoBoundary = response.boundaryResults[key];
              newBoundaryResults[aiBaseIndex] = {
                loading: false,
                score: demoBoundary?.score || 0,
                ambiguity: demoBoundary?.ambiguity || '',
                reasoning: demoBoundary?.reasoning || ''
              };
              boundaryMatchedCount++;
            }
          }
        });
        if (boundaryMatchedCount > 0) {
          this.utilityService.showSnackBar(`Boundary data applied to ${boundaryMatchedCount} models`, 2000);
        }
      }

      // Ensure all images have result structures initialized, even if not in the file
      this.testImages.forEach((_, imageIndex) => {
        if (!newAnalysisResults[imageIndex]) { newAnalysisResults[imageIndex] = {}; }
        if (!newShowFullAnalysis[imageIndex]) { newShowFullAnalysis[imageIndex] = {}; }
        this.promptTypes.forEach(promptType => {
          if (!newAnalysisResults[imageIndex][promptType.key]) {
            newAnalysisResults[imageIndex][promptType.key] = { loading: false, result: '' };
          }
          if (!newShowFullAnalysis[imageIndex][promptType.key]) {
            newShowFullAnalysis[imageIndex][promptType.key] = false;
          }
        });
      });

      // Assign new objects to trigger change detection
      this.analysisResults = newAnalysisResults;
      this.showFullAnalysis = newShowFullAnalysis;
      this.boundaryResults = newBoundaryResults;

      this.demoDataLoaded = true;
      console.log('Data processing finished.');
    }
  }

  // Export analysis results to JSON
  exportResultsToJson(): void {
    const simplePrompts = this.promptTypes.map(({ key, id, name, prompt }) => ({ key, id, name, prompt }));

    const exportData = {
      version: '2.0',
      description: 'AI Analysis Results Export (AI Base Data)',
      timestamp: new Date().toISOString(),
      aiProvider: this.settingsService.aiProvider,
      frameCount: this.aiFramesCount,
      prompts: simplePrompts.filter(p => p.key !== 'boundary'),
      boundaryPrompt: simplePrompts.find(p => p.key === 'boundary'),
      images: this.testImages,
      analysisResults: this.analysisResults,
    boundaryResults: this.boundaryResults,
      metadata: {
        exportedBy: this.firebaseAuth.currentUser?.uid || 'unknown',
        totalImages: this.testImages.length,
        totalPrompts: this.promptTypes.length,
        completedAnalyses: this.getCompletedAnalysesCount(),
        analysisMode: this.aiFramesCount === 1 ? 'image' : 'video',
        dataSource: 'ai-base.json with applied demo results where available'
      }
    };

    const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `ai-base-analysis-results-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    this.utilityService.showSnackBar('AI analysis results exported to JSON file', 3000);
  }

  // Count completed analyses
  private getCompletedAnalysesCount(): number {
    let count = 0;
    this.testImages.forEach((_, imageIndex) => {
      this.promptTypes.forEach(promptType => {
        if (this.hasResult(imageIndex, promptType.key)) {
          count++;
        }
      });
    });
    return count;
  }

  // Generate variation column names
  getColumnVariationName(index: number): string {
    if (index === 0) {
      return 'Gemini Analysis';
    } else if (index === 1) {
      return 'Gemini Analysis WIKI';
    } else if (index === 2) {
      return 'Boundary Analysis';
    } else {
      return `Analysis ${index + 1}`;
    }
  }

    // Open image dialog
    openImageDialog(image: {name: string; posterUrl: string; videoUrl: string; preview_link_web?: string}): void {
    this.selectedImage = image;

    const dialogRef = this.dialog.open(this.imageDialogTemplate, {
      width: '90vw',
      maxWidth: '800px',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'image-dialog-container'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.selectedImage = null;
    });
  }

  // Temperature control methods
  onTemperatureChange(value: number): void {
    this.aiTemperature = Number(value.toFixed(1));
    this.settingsService.aiTemperature = this.aiTemperature;
    this.utilityService.showSnackBar(`AI temperature set to ${this.aiTemperature} (${this.aiTemperature < 0.5 ? 'More focused' : 'More creative'})`, 2000);
  }

  resetTemperatureToDefault(): void {
    this.aiTemperature = 0.4;
    this.settingsService.aiTemperature = this.aiTemperature;
    this.utilityService.showSnackBar('AI temperature reset to default (0.4)', 2000);
  }

  onThinkingBudgetChange(value: number): void {
    this.aiThinkingBudget = Number(value);
    this.settingsService.aiThinkingBudget = this.aiThinkingBudget;
    this.utilityService.showSnackBar(`OpenAI thinking budget set to ${this.aiThinkingBudget} tokens`, 2000);
  }

  resetThinkingBudgetToDefault(): void {
    this.aiThinkingBudget = 4000;
    this.settingsService.aiThinkingBudget = this.aiThinkingBudget;
    this.utilityService.showSnackBar('OpenAI thinking budget reset to default (4000 tokens)', 2000);
  }

  // Description Accuracy Methods - Updated for prompt-specific ratings
  getAverageRating(imageIndex: number, promptId: string): number {
    // return this.averageRatings[imageIndex]?.[promptId] || 0;
    return 0;
  }

  getRatingCount(imageIndex: number, promptId: string): number {
    // return this.ratingCounts[imageIndex]?.[promptId] || 0;
    return 0;
  }

  getUserRating(imageIndex: number, promptId: string): number | null {
    // return this.userRatings[imageIndex]?.[promptId] !== undefined ? this.userRatings[imageIndex][promptId] : null;
    return null;
  }


  // Boundary Conditions Methods
  isBoundaryAnalyzing(imageIndex: number): boolean {
    return this.boundaryResults[imageIndex]?.loading || false;
  }

  hasBoundaryResult(imageIndex: number): boolean {
    return this.boundaryResults[imageIndex] && !this.boundaryResults[imageIndex].loading && this.boundaryResults[imageIndex].score > 0;
  }

  getBoundaryScore(imageIndex: number): number {
    return this.boundaryResults[imageIndex]?.score || 0;
  }

  getAmbiguityLevel(imageIndex: number): string {
    return this.boundaryResults[imageIndex]?.ambiguity + ' Ambiguity' || '';
  }

  getBoundaryScoreColorClass(imageIndex: number): string {
    const score = this.getBoundaryScore(imageIndex);
    if (score >= 90) return 'score-excellent';
    if (score >= 70) return 'score-good';
    if (score >= 50) return 'score-medium';
    if (score >= 30) return 'score-poor';
    return 'score-very-poor';
  }

  async analyzeBoundaryConditions(imageIndex: number, mode?: string): Promise<void> {
    // Check if clarity analysis was cancelled (for batch processing)
    if (this.isClarityAnalysisCancelled) {
      return;
    }

    // Check if image exists
    if (!this.testImages[imageIndex]) {
      this.utilityService.showSnackBar('Image not found', 3000);
      return;
    }

    if (!this.boundaryResults[imageIndex]) {
      this.boundaryResults[imageIndex] = { loading: false, score: 0, ambiguity: '', reasoning: '' };
    }

    this.boundaryResults[imageIndex].loading = true;

    try {
      // Check for cancellation again after starting
      if (this.isClarityAnalysisCancelled) {
        this.boundaryResults[imageIndex].loading = false;
        return;
      }

      const image = this.testImages[imageIndex];
      const originalAnalysis = this.getShortDescription(imageIndex, 'gemini');

      // Check if we have analysis result
      if (!originalAnalysis || originalAnalysis.trim() === '') {
        this.utilityService.showSnackBar('Please run AI analysis first', 3000);
        this.boundaryResults[imageIndex].loading = false;
        return;
      }

      // Use video URL if available, otherwise fallback to poster URL
      const contentUrl = image.videoUrl || image.posterUrl;
      const isVideo = !!image.videoUrl;

      // Boundary analysis prompt
      const boundaryPromptTemplate = this.promptTypes.find(p => p.key === 'boundary')?.prompt || this.getBoundaryPromptTemplate();
      const boundaryPrompt = boundaryPromptTemplate.replace('{{originalAnalysis}}', originalAnalysis);



      const mockCard = {
        id: `boundary_test_${imageIndex}`,
        cardSharingId: `boundary_test_sharing_${imageIndex}`,
        cardTitle: image.name,
        cardContentWeb: contentUrl,
        cardContentMobile: contentUrl,
        cardPosterMobile: image.posterUrl,
        cardPosterWeb: image.posterUrl,
        cardDescription: isVideo
          ? `[BOUNDARY_MODE][VIDEO_MODE] Clarity analysis with ${this.aiFramesCount} frames`
          : `[BOUNDARY_MODE][IMAGE_MODE] Clarity analysis`,
        cardAuthor: 'Test',
        cardCategory: 'Test',
        modifiedDate: new Date().toISOString(),
        cardPrice: 0,
        purchaseStatus: CARD_PURCHASE_STATUS.DEFAULT_3DWAY,
        cardType: CARD_TYPE.MODEL
      };

      // Save original settings
      const originalPrompt = this.settingsService.aiPrompt;
      const originalFramesCount = this.settingsService.aiFramesCount;
      const originalTemperature = this.settingsService.aiTemperature;
      const originalThinkingBudget = this.settingsService.aiThinkingBudget;

      this.settingsService.aiPrompt = boundaryPrompt;
      this.settingsService.aiTemperature = 0.3; // Lower temperature for more consistent analysis
      this.settingsService.aiThinkingBudget = this.aiThinkingBudget; // Use current thinking budget setting

      try {
        // Check for cancellation before making AI request
        if (this.isClarityAnalysisCancelled) {
          this.boundaryResults[imageIndex].loading = false;
          return;
        }

        const useAdvancedGemini = mode === 'advanced-mode';
        let providerModel: string | undefined;
        if (this.settingsService.aiProvider === 'openai') {
          providerModel = this.settingsService.aiOpenAIModel;
        } else if (useAdvancedGemini) {
          providerModel = 'googleai/gemini-2.5-pro';
        }

        const aiResponse = await this.cardService.getDataFromAiDescription(mockCard, this.settingsService.aiProvider, providerModel, this.aiThinkingBudget);

        // Check for cancellation after AI request
        if (this.isClarityAnalysisCancelled) {
          this.boundaryResults[imageIndex].loading = false;
          return;
        }

        // Parse the boundary analysis response
        const responseText = aiResponse.short_description || aiResponse.technical_description || '';

        console.log('Boundary analysis raw response:', responseText);

        // Extract JSON from response (it might contain additional text)
        let boundaryData;
        try {
          // First, try to parse the entire response as JSON
          boundaryData = JSON.parse(responseText);
        } catch (parseError) {
          console.warn('Failed to parse entire response as JSON, trying to extract JSON object:', parseError);

          try {
            // Try to find JSON in the response using a more robust regex
            const jsonMatch = responseText.match(/\{[\s\S]*?\}/);
            if (jsonMatch) {
              boundaryData = JSON.parse(jsonMatch[0]);
            } else {
              throw new Error('No JSON found in response');
            }
          } catch (extractError) {
            console.error('Failed to extract and parse JSON from response:', extractError);
            console.log('Raw response for parsing:', responseText);

            // Fallback: try to extract values manually if JSON parsing fails
            const clarityMatch = responseText.match(/"clarity_score"\s*:\s*(\d+)/);
            const ambiguityMatch = responseText.match(/"ambiguity_level"\s*:\s*"((?:\\.|[^"\\])*)"/);
            const reasoningMatch = responseText.match(/"reasoning"\s*:\s*"((?:\\.|[^"\\])*)"/);

            boundaryData = {
              clarity_score: clarityMatch ? parseInt(clarityMatch[1], 10) : 50,
              ambiguity_level: ambiguityMatch ? ambiguityMatch[1].replace(/\\"/g, '"').replace(/\\n/g, '\n') : 'Medium',
              reasoning: reasoningMatch ? reasoningMatch[1].replace(/\\"/g, '"').replace(/\\n/g, '\n') : 'Failed to extract reasoning'
            };
          }
        }

        this.boundaryResults[imageIndex] = {
          loading: false,
          score: boundaryData.clarity_score || 0,
          ambiguity: boundaryData.ambiguity_level || 'Unknown',
          reasoning: boundaryData.reasoning || ''
        };

        const providerFriendlyName = this.getProviderFriendlyName();
        this.utilityService.showSnackBar(`${providerFriendlyName} boundary analysis completed: ${this.boundaryResults[imageIndex].score}% clarity`, 2000);

      } finally {
        this.settingsService.aiPrompt = originalPrompt;
        this.settingsService.aiFramesCount = originalFramesCount;
        this.settingsService.aiTemperature = originalTemperature;
        this.settingsService.aiThinkingBudget = originalThinkingBudget;
      }

    } catch (error) {
      console.error('Error analyzing boundary conditions:', error);
      const providerFriendlyName = this.getProviderFriendlyName();
      this.boundaryResults[imageIndex] = {
        loading: false,
        score: 0,
        ambiguity: 'Error',
        reasoning: 'Analysis failed'
      };
      this.utilityService.showSnackBar(`${providerFriendlyName} boundary analysis failed`, 3000);
    }
  }

  //   private async loadRatingForImageAndPrompt(imageIndex: number, imageName: string, promptId: string): Promise<void> {
  //   if (!imageName || imageIndex < 0 || !promptId) return;

  //   try {
  //     // Load rating stats from Firebase
  //     const stats = await this.ratingService.getPromptRatingStats(imageName, promptId).toPromise();

  //     // Only update the UI if we got valid stats
  //     if (stats) {
  //       // Only update average if there are ratings
  //       if (stats.totalRatings > 0) {
  //         this.averageRatings[imageIndex][promptId] = stats.averageRating > 0 ? stats.averageRating : null;
  //         this.ratingCounts[imageIndex][promptId] = stats.totalRatings;
  //       } else {
  //         // No ratings exist for this model-prompt combination
  //         this.averageRatings[imageIndex][promptId] = null;
  //         this.ratingCounts[imageIndex][promptId] = 0;
  //       }
  //     } else {
  //       // No stats document exists
  //       this.averageRatings[imageIndex][promptId] = null;
  //       this.ratingCounts[imageIndex][promptId] = 0;
  //     }

  //     // Always update user's rating (it could be null if deleted)
  //     const userRating = await this.ratingService.getUserPromptRating(imageName, promptId);
  //     this.userRatings[imageIndex][promptId] = userRating !== null && userRating !== undefined ? userRating : null;

  //   } catch (error) {
  //     console.error('Error loading ratings for image and prompt:', error);
  //     // Ensure we have safe defaults
  //     this.averageRatings[imageIndex][promptId] = null;
  //     this.ratingCounts[imageIndex][promptId] = 0;
  //     this.userRatings[imageIndex][promptId] = null;
  //   }
  // }

  // Keep old method for backward compatibility if needed elsewhere
  private async loadRatingForImage(imageIndex: number, imageName: string): Promise<void> {
    // Load ratings for all prompts for this image
    console.log(`Loading ratings for image: ${imageName} at index ${imageIndex}`);
    // this.promptTypes.forEach(promptType => {
    //   this.loadRatingForImageAndPrompt(imageIndex, imageName, promptType.id);
    // });
  }

  /**
   * Format rating for display (show N/A if no rating exists)
   */

  formatRating(rating: number | null): string {
    return rating !== null && rating !== undefined ? rating.toFixed(1) : '—';
  }

  getRatingColorClass(rating: number): string {
    if (rating >= 8) return 'rating-high';
    if (rating >= 5) return 'rating-medium';
    return 'rating-low';
  }

  // onRatingChange(imageIndex: number, rating: string): void {
  //   const ratingValue = parseInt(rating, 10);
  //   if (ratingValue >= 1 && ratingValue <= 10) {
  //     this.userRatings[imageIndex] = ratingValue;
  //     this.saveRatingToFirebase(imageIndex, ratingValue);
  //     this.utilityService.showSnackBar(`Rating saved: ${ratingValue}/10`, 2000);
  //   }
  // }

  // Handle rating change from the slider - Updated for prompt-specific ratings
  onRatingChange(event: any, imageIndex: number, promptId: string): void {
    const newRating = parseFloat(event.target?.value) || 1;

    // Only save if the value actually changed and it's not the initial setting
    if (this.userRatings[imageIndex][promptId] !== newRating) {
      this.userRatings[imageIndex][promptId] = newRating;

      // Add a small delay to prevent immediate saving during initial slider setup
      setTimeout(() => {
        if (this.userRatings[imageIndex][promptId] === newRating) {
          // this.saveRatingToFirebase(imageIndex, newRating, promptId);
          this.utilityService.showSnackBar(`Rating saved: ${newRating}/10`, 2000);
        }
      }, 100);
    }
  }

  analyzeWithProModel(imageIndex: number, promptTypeKey: string): void {
    if (this.selectedProvider === 'gemini') {
      this.analyzeImage(imageIndex, promptTypeKey, 'googleai/gemini-2.5-pro');
    } else {
      this.utilityService.showSnackBar('Pro model analysis is only available for Gemini provider.', 2000);
    }
  }

  // Start rating - initialize with value 5 and show slider - Updated for prompt-specific ratings
  startRating(imageIndex: number, promptId: string): void {
    this.userRatings[imageIndex][promptId] = 5; // Default to middle value
    // Don't save to Firebase yet - let user adjust first
  }

  // Save rating to Firebase - Updated for prompt-specific ratings
  async saveRating(imageIndex: number, imageName: string, promptId: string): Promise<void> {
    const rating = this.userRatings[imageIndex][promptId];
    if (this.isSavingRating[imageIndex][promptId] || !rating || rating === null) return;

    try {
      this.isSavingRating[imageIndex][promptId] = true;
      // await this.ratingService.ratePrompt(imageName, promptId, rating);

      // Refresh the rating display
      // await this.loadRatingForImageAndPrompt(imageIndex, imageName, promptId);
      this.utilityService.showSnackBar('Rating saved successfully', 2000);
    } catch (error) {
      console.error('Error saving rating:', error);
      this.utilityService.showSnackBar('Failed to save rating', 3000);
    } finally {
      this.isSavingRating[imageIndex][promptId] = false;
    }
  }

  // Helper method for backward compatibility
  private async saveRatingToFirebase(imageIndex: number, rating: number, promptId: string): Promise<void> {
    const imageName = this.testImages[imageIndex]?.name;
    if (imageName) {
      await this.saveRating(imageIndex, imageName, promptId);
    }
  }

  /**
   * Delete a single rating for an image and prompt
   */
  async deleteRating(imageIndex: number, promptId: string): Promise<void> {
    const imageName = this.testImages[imageIndex]?.name;
    if (!imageName) return;

    try {
      // await this.ratingService.deletePromptRating(imageName, promptId);

      // Update local state immediately for instant UI feedback
      this.userRatings[imageIndex][promptId] = null;

      // Reload the rating stats to get fresh data from Firebase
      // await this.loadRatingForImageAndPrompt(imageIndex, imageName, promptId);

      this.utilityService.showSnackBar('Rating deleted', 2000);
    } catch (error) {
      console.error('Error deleting rating:', error);
      this.utilityService.showSnackBar('Failed to delete rating', 2000);
    }
  }

  /**
   * Delete all ratings by the current user for the current analysis table
   */
  async deleteAllRatings(): Promise<void> {
    const confirmDelete = confirm(POPUP_TEXT.SYSTEM_CONFIRM_MESSAGES.DELETE_ALL_RATINGS);
    if (!confirmDelete) return;

    try {
      this.isDeletingRatings = true;

      // Collect all model-prompt combinations that have user ratings
      const combinationsToDelete: Array<{ modelId: string; promptId: string; imageIndex: number }> = [];

      this.testImages.forEach((image, imageIndex) => {
        if (image?.name) {
          this.promptTypes.forEach(promptType => {
            if (this.userRatings[imageIndex]?.[promptType.id] !== null &&
                this.userRatings[imageIndex]?.[promptType.id] !== undefined) {
              combinationsToDelete.push({
                modelId: image.name,
                promptId: promptType.id,
                imageIndex
              });
            }
          });
        }
      });

      if (combinationsToDelete.length === 0) {
        this.utilityService.showSnackBar('No ratings to delete', 2000);
        return;
      }

      // Delete ratings from Firebase
      for (const { modelId, promptId, imageIndex } of combinationsToDelete) {
        try {
          // await this.ratingService.deletePromptRating(modelId, promptId);

          // Update local state immediately
          this.userRatings[imageIndex][promptId] = null;

          // Reload rating stats to get updated averages and counts
          // await this.loadRatingForImageAndPrompt(imageIndex, modelId, promptId);
        } catch (error) {
          console.error(`Failed to delete rating for ${modelId}-${promptId}:`, error);
        }
      }

      this.utilityService.showSnackBar(`Deleted ${combinationsToDelete.length} ratings successfully`, 3000);
    } catch (error) {
      console.error('Error deleting ratings:', error);
      this.utilityService.showSnackBar('Failed to delete ratings', 3000);
    } finally {
      this.isDeletingRatings = false;
    }
  }

  /**
   * Get count of user ratings in the current analysis table (across all prompt combinations)
   */
  getUserRatingsCount(): number {
    let count = 0;
    this.testImages.forEach((image, imageIndex) => {
      if (image?.name) {
        this.promptTypes.forEach(promptType => {
          if (this.userRatings[imageIndex]?.[promptType.id] !== null &&
              this.userRatings[imageIndex]?.[promptType.id] !== undefined) {
            count++;
          }
        });
      }
    });
    return count;
  }

  /**
   * Get text for delete button based on ratings count
   */
  getDeleteButtonText(): string {
    const count = this.getUserRatingsCount();
    if (count === 0) return 'No Ratings to Delete';
    return `Delete ${count} Rating${count > 1 ? 's' : ''}`;
  }

  // Remove loadDemoDataManually method - not needed
  // Remove switchDemoDataMode method - not needed
  // Remove getDemoDataFileName method - not needed
  // Remove getDemoDataDisplayName method - not needed

  // ===== MODEL COMMENT METHODS =====

  /**
   * Load comment for a specific image/model
   */
  private async loadCommentForImage(imageIndex: number, imageName: string): Promise<void> {
    if (!imageName || imageIndex < 0) return;

    try {
      this.ratingService.getModelComment(imageName).subscribe({
        next: (comment) => {
          if (comment) {
            this.modelComments[imageIndex] = comment.comment || '';
            this.modelCommentsLastUpdatedBy[imageIndex] = comment.lastUpdatedBy || '';
            this.modelCommentsLastUpdated[imageIndex] = comment.lastUpdated;
            // Show form if comment exists
            this.showCommentForm[imageIndex] = this.hasComment(imageIndex);
          } else {
            this.modelComments[imageIndex] = '';
            this.modelCommentsLastUpdatedBy[imageIndex] = '';
            this.modelCommentsLastUpdated[imageIndex] = null;
            this.showCommentForm[imageIndex] = false;
          }
        },
        error: (error) => {
          console.error('Error loading comment for image:', error);
          this.modelComments[imageIndex] = '';
          this.modelCommentsLastUpdatedBy[imageIndex] = '';
          this.modelCommentsLastUpdated[imageIndex] = null;
          this.showCommentForm[imageIndex] = false;
        }
      });
    } catch (error) {
      console.error('Error loading comment for image:', error);
      this.modelComments[imageIndex] = '';
      this.modelCommentsLastUpdatedBy[imageIndex] = '';
      this.modelCommentsLastUpdated[imageIndex] = null;
      this.showCommentForm[imageIndex] = false;
    }
  }

  /**
   * Save comment for a model
   */
  async saveComment(imageIndex: number): Promise<void> {
    const imageName = this.testImages[imageIndex]?.name;
    const comment = this.modelComments[imageIndex];

    if (!imageName) return;

    // Check character limit
    if (comment && comment.length > 500) {
      this.utilityService.showSnackBar('Comment exceeds 500 character limit', 3000);
      return;
    }

    try {
      this.isSavingComment[imageIndex] = true;
      await this.ratingService.saveModelComment(imageName, comment);

      // Reload comment to get updated lastUpdatedBy info
      await this.loadCommentForImage(imageIndex, imageName);

      this.utilityService.showSnackBar('Comment saved successfully', 2000);
    } catch (error) {
      console.error('Error saving comment:', error);
      this.utilityService.showSnackBar('Failed to save comment', 3000);
    } finally {
      this.isSavingComment[imageIndex] = false;
    }
  }

  /**
   * Clear comment for a model
   */
  async clearComment(imageIndex: number): Promise<void> {
    const imageName = this.testImages[imageIndex]?.name;
    if (!imageName) return;

    const confirmClear = confirm(POPUP_TEXT.SYSTEM_CONFIRM_MESSAGES.CLEAR_COMMENT);
    if (!confirmClear) return;

    try {
      this.isSavingComment[imageIndex] = true;
      await this.ratingService.deleteModelComment(imageName);

      // Update local state
      this.modelComments[imageIndex] = '';

      // Reload comment to get updated info
      await this.loadCommentForImage(imageIndex, imageName);

      this.utilityService.showSnackBar('Comment cleared', 2000);
    } catch (error) {
      console.error('Error clearing comment:', error);
      this.utilityService.showSnackBar('Failed to clear comment', 3000);
    } finally {
      this.isSavingComment[imageIndex] = false;
    }
  }

  /**
   * Handle comment input change with debouncing
   */
  onCommentChange(imageIndex: number): void {
    // Simple debouncing - could be enhanced with proper debouncing if needed
    // For now, we'll save manually with a button
  }

  /**
   * Show comment form for adding new comment
   */
  showCommentInput(imageIndex: number): void {
    this.showCommentForm[imageIndex] = true;
  }

  /**
   * Check if comment has content
   */
  hasComment(imageIndex: number): boolean {
    return this.modelComments[imageIndex] && this.modelComments[imageIndex].trim().length > 0;
  }

  /**
   * Get display of when comment was last updated
   */
  getLastUpdatedByDisplay(imageIndex: number): string {
    const timestamp = this.modelCommentsLastUpdated[imageIndex];
    if (!timestamp) return '';

    // Convert Firestore timestamp to Date
    let date: Date;
    if (timestamp?.toDate) {
      // Firestore Timestamp object
      date = timestamp.toDate();
    } else if (timestamp?.seconds) {
      // Firestore timestamp data
      date = new Date(timestamp.seconds * 1000);
    } else if (timestamp instanceof Date) {
      date = timestamp;
    } else {
      return '';
    }

    // Format date and time
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);

    if (diffDays > 0) {
      return `Last updated: ${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    } else if (diffHours > 0) {
      return `Last updated: ${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    } else {
      const diffMinutes = Math.floor(diffMs / (1000 * 60));
      if (diffMinutes > 0) {
        return `Last updated: ${diffMinutes} minute${diffMinutes > 1 ? 's' : ''} ago`;
      } else {
        return 'Last updated: just now';
      }
    }
  }

}
